// latest: zhangmyh 2017-12-18 2:30 PM
import { Get, URLs } from 'common'
import bookList from 'collection/ag_reject'
import './index.less'
/* global ko */

export default function (params) {
  // 常用语
  this.leftVisible = ko.observable(false)
  this.toggleLeft = function () {
    this.leftVisible(!this.leftVisible())
  }
  const bookTypes = ko.observableArray([])
  this.bookTypes = bookTypes
  this.curType = ko.observable('0')
  this.books = ko.observableArray([])
  this.books = bookList.datatable
  this.showPrev = ko.observable(false)
  this.showNext = ko.observable(false)
  this.refreshBooks = async function (pageIndex) {
    let type = this.curType()
    let params = {
      typeId: type,
      pageIndex
    }
    if (type == '0') {
      params.typeId = ''
    }
    await bookList.load(params)
    let data = bookList.data
    this.showPrev((data.pageIndex != 0))
    this.showNext((data.totalPage > 1 && data.totalPage - 1 != data.pageIndex))
  }
  this.changeBookType = function () {
    this.refreshBooks(0)
  }
  this.prev = function () {
    this.refreshBooks(bookList.data.pageIndex - 1)
  }
  this.next = function () {
    this.refreshBooks(bookList.data.pageIndex + 1)
  }
  this.changeBookType()
  Get(URLs.rej_getType.url, {}).then(function (result, state) {
    if (state == 'success' && result.status == 1) {
      let list = result.data.result.map(function (item) {
        return {
          value: item.id + '',
          name: item.title
        }
      })
      list.unshift({ value: '0', name: '全部' })
      bookTypes(list)
    }
  })

  this.title = params.title || '请输入驳回原因'
  this.maxlength = params.maxlength || 200
  this.reason = ko.observable('')
  this.visible = params.visible
  let handleOK = params.onOK || function () {
    return true
  }
  let handleCancel = params.onCancel || function () {}
  this.onOK = async function () {
    let result = await handleOK(this.reason())
    if (result) {
      this.visible(false)
    }
  }
  this.onCancel = function () {
    handleCancel(this.reason())
    this.visible(false)
  }
  this.addText = function (text) {
    let reason = this.reason()
    if (reason == '') {
      reason = text
    } else {
      reason += '\n' + text
    }
    this.reason(reason)
  }
}



// WEBPACK FOOTER //
// ./src/components/confirm-with-reason/index.js